import React from 'react';
import { simTokens } from '../sim/ui/tokens';

const SimScreenSkeleton: React.FC = () => {
  return (
    <div className={`${simTokens.shell} flex flex-col`} aria-busy="true">
      <span className="sr-only">Loading...</span>
      <header className={simTokens.header}>
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="space-y-2">
            <div className="h-3 w-24 rounded-full bg-surface-input animate-pulse" />
            <div className="h-6 w-52 rounded-input bg-surface-input animate-pulse" />
          </div>
          <div className="flex items-center gap-2">
            <div className="h-4 w-28 rounded-full bg-surface-input animate-pulse" />
            <div className="h-7 w-16 rounded-full bg-surface-input animate-pulse" />
          </div>
          <div className="h-3 w-44 rounded-full bg-surface-input animate-pulse" />
        </div>
      </header>

      <main className="flex-1 py-6">
        <div className="max-w-3xl mx-auto">
          <div className={simTokens.card}>
            <div className="mb-6 space-y-3">
              <div className="h-3 w-20 rounded-full bg-surface-input animate-pulse" />
              <div className="h-6 w-64 rounded-input bg-surface-input animate-pulse" />
            </div>

            <div className="space-y-4">
              <div className="h-4 w-full rounded-input bg-surface-input animate-pulse" />
              <div className="h-4 w-11/12 rounded-input bg-surface-input animate-pulse" />
              <div className="h-4 w-9/12 rounded-input bg-surface-input animate-pulse" />
            </div>

            <div className="mt-8 rounded-card border border-line bg-surface-alt p-4 sm:p-5">
              <div className="h-4 w-40 rounded-input bg-surface-input animate-pulse" />
              <div className="mt-3 h-11 w-full rounded-input bg-surface-input animate-pulse" />
            </div>
          </div>
        </div>
      </main>

      <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95">
        <div className="mx-auto flex w-full max-w-5xl justify-end px-5 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:px-6">
          <div className="h-10 w-full sm:w-32 rounded-input bg-surface-input animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default SimScreenSkeleton;
